/*
Vue component that handle the dynamic of watch finder page. Start to populate
page with ajax request. Then listen on filters events such as:
- toggleFilters
- toggleDropdownMenu

Main function is filterList that filters product items. `app_data` is
a json representation of data defined in Watch.php file. See `single-watch-finder.twig` 
*/

import { readCookie } from './util';

function initWatchFinder()
{
    // console.log("init watch fidner");
    if (!$("#watch-finder").length || typeof app_data === "undefined") {
        return false;
    }

    new Vue({
        el: '#watch-finder',
        delimiters: ['[[',']]'],
        data: {...app_data, items : null, myaccount : false},
        computed:
        {
            filtersToggled : function()
            {
                return (this.activeFilters) ? "active" : "";
            },
            getMyAccountUrl : function () {
                if(this.items) {
                  return `${myAccountUrl}/favorites?save=${this.items.map(e => e.ref_number)}`;
                }
            }
        },
        methods :
        {
            toggleFilters : function(status)
            {
                this.activeFilters = status;
            },

            toggleDropdownMenu : function (type)
            {
                if ($("."+type).hasClass("show")) {
                    $("."+type).removeClass("show");
                    this.filterList();
                } else {
                    $(".advanced-search__fieldset").removeClass("show");
                    $("."+type).addClass("show");
                }
            },

            closeAndUpdate : function (event)
            {
                $(".advanced-search__fieldset").removeClass("show");
                this.filterList();
            },

            filterList : function ()
            {
                // _log("filter list");
                this.public_list = null;

                this.updateList();

                let itemList = [];
                // _log(this.results);
                for(let i=0; i<= this.results.length; i++) {
                    let item = this.results[i];

                    if(typeof item !== "object"){
                        continue;
                    }

                    let passed = true;

                    if (this.is_new && (typeof item.is_new === "undefined" || !item.is_new)) {
                        passed = false;
                    }

                    if (this.limited && !item.limitations) {
                        passed = false;
                    }

                    if (this.case_form && item.case_form !== this.case_form) {
                        passed = false;
                    }

                    if (this.case_material != 0 && item.case_material !== this.case_material) {
                        passed = false;
                    }

                    if (this.strap_material != 0 && item.strap_material !== this.strap_material) {
                        passed = false;
                    }

                    if (this.movement_type && item.movement_type !== this.movement_type) {
                        passed = false;
                    }

                    if ( typeof this.collections === "object" && this.collections.length) {
                        if (this.collections.indexOf(item.collection) == -1) {
                            passed = false;
                        }
                    }

                    if ( typeof this.functionalities === "object" && this.functionalities.length) {
                        for(let f=0;f<this.functionalities.length;f++) {
                            let fkey = this.functionalities[f];
                            if (item.functionalities[fkey] == 0) {
                                passed = false;
                                break;
                            }

                        }
                    }

                    if (this.case_diameter) {
                        if (this.case_diameter === "small" && item.case_diameter > 39) {
                            passed = false;
                        } else if (this.case_diameter === "medium" && (item.case_diameter < 39 || item.case_diameter > 42) ) {
                            passed = false;
                        } else if (this.case_diameter === "large" && (item.case_diameter < 42 || item.case_diameter > 44) )  {
                            passed = false;
                        } else if (this.case_diameter === "xl" && item.case_diameter < 44 ) {
                            passed = false;
                        }
                    }


                    if (passed) {
                        itemList.push(item);
                    }
                }

                this.filtered_list = itemList;
                this.updatePublicList();
                $([document.documentElement, document.body]).animate({ scrollTop: $("#body").offset().top }, 500);
            },

            updateList : function ()
            {
                const request_fields = [
                    "case_form",
                    "movement_type",
                    "case_diameter",
                    "case_material",
                ];

                // _log(request_fields);
                var request_data = {};

                for(var i=0; i<request_fields.length; i++) {
                    request_data[request_fields[i]] = "";

                    if (typeof this[request_fields[i]] === "string"
                            && this[request_fields[i]]
                                && this[request_fields[i]].trim()) {
                        request_data[request_fields[i]] = this[request_fields[i]];
                    }
                }

                request_data["is_new"]    = (this.is_new) ? 1 : 0;
                request_data["limited"] = (this.limited) ? 1 : 0;


                if (typeof this.collections === "object" && this.collections.length) {
                    request_data["collections"] = this.collections;
                }

                if (this.strap_material) {
                    request_data["strap_material"] = this.strap_material;
                }

                if (typeof this.functionalities === "object" && this.functionalities.length) {
                    request_data["functionalities"] = this.functionalities;
                }

                this.query_args = request_data;

                const query_string = this.httpHuildQuery();
                if (query_string) {
                    window.history.pushState('page2', 'Watchfinder | Glashütte Original', this.siteurl+query_string);
                }

                $(".advanced-search__fieldset").removeClass("is-selected");
                for (var type in request_data) {
                    if (request_data[type] != "0" && request_data[type].length) {
                        $(".watch-"+type).addClass("is-selected");
                    }
                }

            },

            httpHuildQuery: function ()
            {
                // _log(this.query_args);
                let query_string = "";
                for (let key in this.query_args) {
                    let value = null;
                    if (typeof this.query_args[key] === "string" || typeof this.query_args[key] === "number" ) {
                        if (value = this.query_args[key]) {
                            query_string += key+"="+value+"&";
                        }
                    } else if (typeof this.query_args[key] === "object") {
                        for(let c=0; c<this.query_args[key].length; c++) {
                            let value = this.query_args[key][c];
                            query_string += key+"[]="+value+"&";
                        }
                    }
                }

                return (query_string) ? "?"+query_string : null;
            },

            getImageSrc : function (card)
            {
                return (window.devicePixelRatio < 1.25) ? card.image : card.medium_image;
                // return 'background-image:url('+src+')';
            },

            ajaxRequest : function()
            {
                const request_data = {};
                request_data.action = "watch_finder";
                request_data.locale = locale;
                this.busy = "busy";
                $.ajax(
                {
                    url: xhrUrl,
                    type: 'GET',
                    data: request_data,
                    dataType: 'JSON',
                    success: this.updateList_ajaxCallback,
                    error: this.updateList_ajaxCallback
                });
            },


            updateList_ajaxCallback : function(response)
            {
                if (typeof response === "object" && response.items && response.items.length >= 0) {
                    // _log("updateList_ajaxCallback");
                    this.results = response.items;
                    this.filtered_list = response.items;
                    this.filterList();
                } else {
                    this.public_list = false;
                    this.results = null;
                }

                this.busy = "";
            },


            updatePublicList : function ()
            {
                const ppp = 12;
                const def = ppp;
                let diff = ppp;
                let current_items = 0;

                if (typeof this.public_list === "object" && this.public_list) {
                    current_items = this.public_list.length;
                }

                if (typeof this.filtered_list === "object" && this.filtered_list.length) {
                    diff = this.filtered_list.length - current_items;
                }

                const count = (diff >= def) ? ppp : diff;

                if (this.filtered_list.length) {
                    this.public_list = this.filtered_list.slice(0, (current_items+count));
                } else {
                    this.public_list = null;
                }

            },


            forceUpdate : function()
            {
                this.$forceUpdate();
            },

            initWindowScroll : function()
            {
                const more_btn = document.getElementById("js_wf-more-btn");
                if (this.isInViewport(more_btn)) {
                    this.updatePublicList();
                }
            },

            isInViewport : function (el)
            {
                if (typeof el === 'object' && el) {
                    const rect = el.getBoundingClientRect();

                    return (
                        rect.top >= 0 &&
                        rect.left >= 0 &&
                        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                 );
                } else {
                    return false;
                }
            },

            getFavorites : function ()
            {
              var data = {
                action: 'get_favorites',
                locale : locale,
                t : Date.now()
              };
    
              $.get(xhrUrl, data, this.getCart__callback);
            },
    
            getCart__callback : function (response)
            {
              if (typeof response === "object" && response.cartItems.length) {
                this.items = response.cartItems;
              } else {
                this.items = null;
              }
            },
        }, // close methods
        created: function()
        {
            this.ajaxRequest();

            // window.addEventListener("resize", this.forceUpdate);
            window.addEventListener("scroll", this.initWindowScroll);
        },
        mounted() {
            eventBus.$on('favorites-changed', () => {
              const myaccountCookie = readCookie('myaccountfavorites');

              this.myaccount = myaccountCookie === 'true';
              
              this.getFavorites();

              console.log('favorites changed...')
            });
          },
          beforeDestroy() {
            eventBus.$off('favorites-changed');
          }

    });

}


export { initWatchFinder };